export default __webpack_public_path__ + "static/media/main.a7d2a009.png";